import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { AuthClientBoundary } from '../../../AuthClientBoundary/AuthClientBoundary';
import { BenefitPod } from './components/BenefitPod/BenefitPod';
import { JoinButton } from './components/JoinButton/JoinButton';

type KioskBenefitsProps = ComponentProps<'div'> & {
  namespace: string;
};

function KioskBenefits({ namespace, className, ...props }: KioskBenefitsProps) {
  const t = useTranslations(namespace);

  const benefitItems = [
    {
      id: 'skip_queue',
      titleKey: 'skip_queue',
    },
    {
      id: 'safe_gambling',
      titleKey: 'safe_gambling',
    },
    {
      id: 'never_miss_a_jackpot',
      titleKey: 'never_miss_a_jackpot',
    },
    {
      id: 'bank_withdrawal',
      titleKey: 'bank_withdrawal',
    },
  ];

  return (
    <div className={twMerge('box-border flex flex-col gap-5 @container', className)} {...props}>
      <div className="flex items-center justify-start gap-2.5">
        <h5>{t('title')}</h5>
      </div>

      <div className="flex flex-col gap-5">
        <div className="grid grid-cols-2 @[600px]:grid-cols-4 gap-4">
          {benefitItems.map(item => (
            <BenefitPod key={item.id} title={t(item.titleKey)} className="h-37.5" />
          ))}
        </div>

        <AuthClientBoundary.LoggedOut>
          <JoinButton />
        </AuthClientBoundary.LoggedOut>
      </div>
    </div>
  );
}

export { KioskBenefits };
